// 展示状态
export const configType = {
  context: 1,
  pic: 2,
  table: 3
};
